import { ISelectItem } from '@lla-platform/core/core-ui'

export enum LeadOutcome {
  NotApplicable = 'NotApplicable',
  UncommittedLead = 'UncommittedLead',
  Booking = 'Booking',
  Appointment = 'Appointment'
}

export const LeadOutcomeToLabel: Record<string, string> = {
  NotApplicable: 'Unknown',
  UncommittedLead: 'Uncommitted Lead',
  Booking: 'Booking',
  Appointment: 'Appointment'
}

export const LeadOutcomeItems: ISelectItem[] = Object.values(LeadOutcome).map((value) => ({
  label: LeadOutcomeToLabel[value],
  value
}))
